import { useState } from "react";
import { Box, Text, Heading } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { UserSignupForm } from "./UserSignupForm";

export const UserSignup = observer(() => {
  const [inviteSentToEmail, setInviteSentToEmail] = useState("");

  if (inviteSentToEmail) {
    return (
      <Box textAlign="center">
        <Heading fontSize="2xl" mb={3} lineHeight="none">
          Thanks for signing up!
        </Heading>
        <Text color="gray.600">
          An onboarding agent will be in touch shortly to provide you with your
          free LeadPro account.
        </Text>
      </Box>
    );
  } else {
    return <UserSignupForm onSubmitSuccess={setInviteSentToEmail} />;
  }
});
